import { render, staticRenderFns } from "./AvailableCourses.vue?vue&type=template&id=959c3544&scoped=true"
import script from "./AvailableCourses.vue?vue&type=script&lang=js"
export * from "./AvailableCourses.vue?vue&type=script&lang=js"
import style0 from "./AvailableCourses.vue?vue&type=style&index=0&id=959c3544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959c3544",
  null
  
)

export default component.exports